






































import { defineComponent, PropType, computed } from '@vue/composition-api'
import { today } from '@/utils/dateLibs'
import moment from 'moment'

export default defineComponent({
  name: 'DatePicker',
  props: {
    label: {
      type: String as PropType<string>,
      default: ''
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    size: {
      type: String as PropType<string>,
      default: 'md'
    },
    placeholder: {
      type: String as PropType<string>,
      default: 'Seleccione una Fecha'
    },
    id: {
      type: String as PropType<string>,
      default: ''
    },
    name: {
      type: String as PropType<string>,
      default: ''
    },
    inputClass: {
      type: String as PropType<string>,
      default: ''
    },
    iconClass: {
      type: String as PropType<string>,
      default: ''
    },
    value: {
      type: [String, Number] as PropType<string|number>,
      default: ''
    },
    msgError: {
      type: String as PropType<string>,
      default: ''
    },
    hasError: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    dateFormatOptions: {
      type: Object,
      default: () => ({
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    dateAvailable: {
      type: Array as PropType<string[]>,
      dafault: () => []
    }
  },
  setup (props) {
    const locale = 'es-ES'
    const labels = {
      es: {
        labelPrevDecade: 'Década anterior',
        labelPrevYear: 'Año anterior',
        labelPrevMonth: 'El mes pasado',
        labelCurrentMonth: 'Mes Actual',
        labelNextMonth: 'Próximo Mes',
        labelNextYear: 'El próximo año',
        labelNextDecade: 'La próxima década',
        labelToday: 'Hoy dia',
        labelSelected: 'Fecha seleccionada',
        labelNoDateSelected: 'Sin fecha elegida',
        labelCalendar: 'Calendario',
        labelNav: 'Navegación de calendario',
        labelHelp: 'Utilice las teclas de flecha para navegar por el calendario'
      }
    }
    const isDateInListAvailable = (dateStr: string) => {
      return props.dateAvailable?.find(d => d === dateStr)
    }
    const getDateDisabled = (ymd: string, date: Date) => {
      if (props.dateAvailable && props.dateAvailable.length > 0) {
        const lastDate = moment(props.dateAvailable[props.dateAvailable.length - 1]).toDate()
        if (isDateInListAvailable(ymd)) {
          return false
        }
        if (date >= lastDate) {
          return false
        }
      } else {
        return false
      }
      return true
    }

    const isTodayAvailable = computed(() => {
      if (props.dateAvailable && props.dateAvailable.length > 0) {
        const lastDate = moment(props.dateAvailable[props.dateAvailable.length - 1]).toDate()
        const _today = moment(today()).toDate()
        return isDateInListAvailable(today()) || _today > lastDate
      }
      return true
    })

    return {
      labels,
      locale,
      getDateDisabled,
      isTodayAvailable
    }
  }
})
